export default __webpack_public_path__ + "static/media/create.fff1c916.png";